import { ColumnMetadata } from "~/components/DataGrid";
import { Emdash } from "~/components/Punctuation";
import { AssetColumns } from "~/modules/assets/types";
import { Link } from "~/components/Link";
import { AssetUserEvents } from "~/modules/analytics/events/assets";
import { Icon } from "~/components/Icon";
import { getAssetClassLinkMetadata } from "~/utils/getAssetClassLinkMetadata";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

export const ASSET_CLASS_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.assetClassName,
    sortsOn: AssetColumns.assetClassName,
    tooltip: CatalogReferenceDataSlugs.asset_class,
    label: "Asset Class",
    type: "string",
    width: 180,
    render: (item) => {
        if (item.isAsset) {
            if (item.asset_class_id === null) {
                return <Emdash />;
            }

            const {
                href,
                icon,
                label = item.asset_class_name,
            } = getAssetClassLinkMetadata(item.asset_class_id);

            if (href === null && label === null) {
                return <Emdash />;
            }

            if (href === null) {
                return label;
            }

            return (
                <Link
                    href={href}
                    analyticsLabel={AssetUserEvents.ClickAssetClass}
                    analyticsEventProperties={{
                        asset_class: item.asset_class_name,
                    }}
                    variant="default"
                    className="flex items-center gap-2"
                >
                    <Icon className="h-3.5" icon={icon} />
                    <span className="dg-overflow">{label}</span>
                </Link>
            );
        }

        return <Emdash />;
    },
};

export const ASSET_CLASS_COLUMN_NO_LINK: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: AssetColumns.assetClassName,
    sortsOn: AssetColumns.assetClassName,
    tooltip: CatalogReferenceDataSlugs.asset_class,
    label: "Asset Class",
    type: "string",
    width: 215,
    render: (item) => {
        if (item.isAsset) {
            if (item.asset_class_id === null) {
                return <Emdash />;
            }

            const { icon, label = item.asset_class_name } =
                getAssetClassLinkMetadata(item.asset_class_id);

            if (label === null) {
                return <Emdash />;
            }

            return (
                <div className="flex items-center gap-2">
                    <Icon className="h-3.5" icon={icon} />
                    <span className="dg-overflow">{label}</span>
                </div>
            );
        }

        return <Emdash />;
    },
};
